import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { TbBrandTiktok } from "react-icons/tb";
import PartsLokator from "../../public/parts_lokator_dark-removebg-preview.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-b from-background via-background/95 to-background border-t border-border/40">
      <div className="container mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 gap-12 mb-12 lg:grid-cols-4">
          <div className="text-left lg:col-span-1">
            {/* <Link to="/" className="flex items-center justify-start mb-4">
              <Wrench className="h-9 w-9 text-primary" />
              <span className="font-extrabold text-2xl bg-gradient-to-r from-primary via-purple-500 to-accent text-transparent bg-clip-text">
                PartsLokator
              </span>
            </Link> */}
            <Link to="/" className="mb-12">
              <img
                alt="PartsLokator Logo"
                className="h-12"
                src={PartsLokator}
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mt-4">
              The smart way to buy and sell used auto parts connecting you with
              trusted businesses to make your search simple and reliable.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:col-span-3 justify-items-start text-left">
            <div className="w-full max-w-[200px]">
              <h3 className="text-lg font-semibold mb-4 text-foreground">
                Quick Links
              </h3>
              <ul className="space-y-2">
                {[
                  { label: "About Us", path: "/about" },
                  { label: "Listings", path: "/listings" },
                  { label: "List Inventory", path: "/list-inventory" },
                  { label: "FAQ", path: "/faq" },
                  { label: "Contact Us", path: "/contact-us" }
                ].map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.path}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors relative group"
                    >
                      {link.label}
                      <span className="absolute left-0 -bottom-0.5 w-0 h-0.5 bg-primary transition-all group-hover:w-full"></span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="w-full max-w-[200px]">
              <h3 className="text-lg font-semibold mb-4 text-foreground">
                Legal
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/privacy"
                    className="text-sm text-muted-foreground hover:text-primary transition-colors relative group"
                  >
                    Privacy Policy
                    <span className="absolute left-0 -bottom-0.5 w-0 h-0.5 bg-primary transition-all group-hover:w-full"></span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    className="text-sm text-muted-foreground hover:text-primary transition-colors relative group"
                  >
                    Terms & Conditions
                    <span className="absolute left-0 -bottom-0.5 w-0 h-0.5 bg-primary transition-all group-hover:w-full"></span>
                  </Link>
                </li>
              </ul>
            </div>

            <div className="w-full max-w-[200px]">
              <h3 className="text-lg font-semibold mb-4 text-foreground">
                Follow Us
              </h3>
              <div className="flex space-x-4 justify-start">
                {[
                  {
                    type: "icon",
                    Icon: Facebook,
                    href: "https://www.facebook.com/share/179u837HEZ/?mibextid=wwXIfr"
                  },
                  {
                    type: "icon",
                    Icon: TbBrandTiktok,
                    href: "https://www.tiktok.com/@partslokator?_t=ZT-90Zk8jbQhAL&_r=1"
                  },
                  {
                    type: "icon",
                    Icon: Instagram,
                    href: "https://www.instagram.com/partslokator?igsh=MTI4Mzl6MmFzbnB1OQ%3D%3D&utm_source=qr"
                  }
                ].map(({ type, Icon, src, href }, i) => (
                  <a
                    key={i}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-full border border-border/40 hover:bg-primary hover:text-white transition-colors flex items-center justify-center"
                  >
                    {type === "icon" ? (
                      <Icon className="h-5 w-5" />
                    ) : (
                      <img src={src} alt="TikTok" className="h-5 w-5" />
                    )}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border/40 pt-6 text-center">
          <p className="text-sm text-muted-foreground">
            &copy; {currentYear} PartsLokator. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Powered by AI • Built with care
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
